webpackJsonp([272377795509025],{

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unicorn = __webpack_require__(114);
	
	var _unicorn2 = _interopRequireDefault(_unicorn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Unicorn = function Unicorn() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { className: 'unicorn-bg-image', src: _unicorn2.default })
	  );
	};
	
	exports.default = Unicorn;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/unicorn.873fbf2f.jpg";

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _jake = __webpack_require__(50);
	
	var _jake2 = _interopRequireDefault(_jake);
	
	var _BackNav = __webpack_require__(15);
	
	var _BackNav2 = _interopRequireDefault(_BackNav);
	
	var _FooterRainbow = __webpack_require__(26);
	
	var _FooterRainbow2 = _interopRequireDefault(_FooterRainbow);
	
	var _Unicorn = __webpack_require__(69);
	
	var _Unicorn2 = _interopRequireDefault(_Unicorn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Gusto = function Gusto() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'main work-page relative' },
	      _react2.default.createElement(_Unicorn2.default, null),
	      _react2.default.createElement(
	        'h1',
	        { className: 'huge-text' },
	        'Coming soon'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'half-page' },
	        'I will publish this page after my recent work at Gusto becomes publicly available. Until then, you\'ll have to use your imagination.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Take my word for it, the work is great ;)'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'half-page' },
	        'If you\'re reading this because you\'re trying to recruit me, then I\'m sorry to inform you that I\'m not looking for new opportunities and I will be joining Amplitude in April of 2020. '
	      ),
	      _react2.default.createElement(_BackNav2.default, null)
	    ),
	    _react2.default.createElement(_FooterRainbow2.default, null)
	  );
	};
	
	exports.default = Gusto;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gusto-js-68a0a91a3ab302365e7d.js